module.exports = __webpack_public_path__ + "static/pizza17-9df3cdad03f54526e516d6fdea1f70a4.webp";